// extracted by mini-css-extract-plugin
export var container = "social-links-module--container--c7c8f";